"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dialog = void 0;
var _Dialog = _interopRequireWildcard(require("./index.parts"));
exports.Dialog = _Dialog;